import Settings from "utils/CarrotConfig"
import { getHeap, loadHeap } from "./heap-loader"
import { reportError } from "utils/ErrorReporting"

export const initializeHeap = () => {
  loadHeap()
  const heap = getHeap()

  try {
    heap.load(Settings.HEAP_ENV_ID, {
      disableTextCapture: true
    })
  } catch (e) {
    console.error(e)
    reportError(e)
  }
}
